import Vue from 'vue';
import { VueperSlides, VueperSlide } from 'vueperslides';

Vue.component('VueperSlides', VueperSlides);
Vue.component('VueperSlide', VueperSlide);
